import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';

import {SnackBarData} from '../../models/notification.model';

@Component({
  selector: 'app-notification',
  standalone: false,
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {

  iconColor: 'success' | 'attention' | 'error';

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData,
    private readonly snackBarRef: MatSnackBarRef<NotificationComponent>,
  ) {
    this.setIconColor();
  }

  private setIconColor(): void {
    if (this.data && this.data.icon !== null) {
      const icon = this.data.icon;
      if (icon === 'done') {
        this.iconColor = 'success';
      }
      if (icon === 'report') {
        this.iconColor = 'error';
      }
      if (icon === 'warning') {
        this.iconColor = 'attention';
      }
    }
  }

  close(): void {
    this.snackBarRef.dismiss();
  }
}
